export const bindQueryParams = (url: string, queryParams: object) => {
  const queryString = Object.entries(queryParams)
    .map(([key, val]) => `${key}=${val}`)
    .join("&");
  return `${url}?${queryString}`;
};

export const rotateArrayToObject = (reportTypeList: any[], id: string) => {
  const index = reportTypeList?.findIndex((item) => item?.test_type_id === id);
  if (index === -1) {
    return;
  }
  const firstPart = reportTypeList?.slice(index);
  const secondPart = reportTypeList?.slice(0, index);
  return firstPart?.concat(secondPart);
};
